export default __webpack_public_path__ + "static/media/pic33.e19a7629.jpg";